import clsx from "clsx";
import React, { FunctionComponent, RefObject } from "react";

import { Button } from "../../ui/Button/Button";
import { ChevronRightIcon } from "../../ui/icons/ChevronRightIcon";
import { OverflowState } from "./useHasOverflow";

export const ScrollControls: FunctionComponent<{
  justifyBetween?: boolean;
  overflowState: OverflowState;
  scrollRef: RefObject<HTMLDivElement>;
}> = ({ justifyBetween, overflowState, scrollRef }) => {
  return (
    <div className="grid grid-cols-2 gap-1 p-1">
      <Button
        onClick={(): void => {
          scrollRef.current?.scrollBy({
            behavior: "smooth",
            left: -scrollRef.current.clientWidth - 80,
          });
        }}
        aria-label="back"
        className={clsx(justifyBetween ? "justify-start" : "justify-end")}
        disabled={!overflowState.left}
      >
        <ChevronRightIcon className="rotate-180" />
      </Button>
      <Button
        onClick={(): void => {
          scrollRef.current?.scrollBy({
            behavior: "smooth",
            left: scrollRef.current.clientWidth - 80,
          });
        }}
        aria-label="forward"
        className={clsx(justifyBetween ? "justify-end" : "justify-start")}
        disabled={!overflowState.right}
      >
        <ChevronRightIcon />
      </Button>
    </div>
  );
};
